import { StyleParamType } from '@wix/tpa-settings';

export const updateCalendarList = (calendarsList, styles) => {
  const visibleToSiteVisitors = calendarsList.filter((cal) => {
    return ['reader', 'writer'].includes(cal.accessRole);
  });

  const listCalendarsCheckboxes = generateListCalendarsCheckboxes(
    calendarsList,
  );

  const visible = () => {
    const visible = [];
    visibleToSiteVisitors.forEach((savedCalendarItem) => {
      calendarsList.forEach((item) => {
        if (item.id === savedCalendarItem.id) {
          item.selected = styles.get(
            listCalendarsCheckboxes[calendarsList.indexOf(savedCalendarItem)],
          );
          //@ts-ignore
          if (typeof visible.find((e) => e.id === item.id) === 'undefined') {
            //@ts-ignore
            visible.push(item);
          }
        }
      });
    });
    return visible;
  };
  const unvisible = () => {
    //@ts-ignore
    return calendarsList.filter((c) => !visible().find((v) => c.id === v.id));
  };

  return [...visible(), ...unvisible()];
};

export const generateListCalendarsCheckboxes = (calendarList) => {
  const listCalendarsCheckboxes = [];
  calendarList.map((item, i) => {
    const listCheckbox = {};
    //@ts-ignore
    listCheckbox.getDefaultValue = () =>
      item.selected !== undefined ? item.selected : true;
    //@ts-ignore
    listCheckbox.type = StyleParamType.Boolean;
    const id = `${item.idCrypt}`;
    //@ts-ignore
    listCheckbox.key = id;
    //@ts-ignore
    listCalendarsCheckboxes[i] = listCheckbox;
  });

  return listCalendarsCheckboxes;
};
